export const BLOG_COMMENTS_APP_DEF_ID = '774b5d26-ac71-4a20-b269-3c6512ac52e9';
export const WIX_COMMENTS_WIDGET_APP_DEF_ID = '91c9d6a7-6667-41fb-b0b4-7d3b3ff0b02e';
export const BLOG_APP_DEF_ID = '14bcded7-0066-7c35-14d7-466cb3f09103';

export const WIX_COMMENTS_WIDGET_COMP_ID = '1c154801-444a-49ad-aee8-325ff74f89b1';
